<template></template>

<script>
  export default {
    name: 'logoutAgent',
    beforeCreate () {
      this.$store.dispatch('logout')
      window.close()
    }
  }
</script>



// WEBPACK FOOTER //
// logoutAgent.vue?b4041bb6